"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
const alert_1 = __importDefault(require("./alert"));
exports.Alert = alert_1.default;
exports.default = alert_1.default;
